module.exports = __webpack_public_path__ + "static/img/mq.b1582df6.svg";